import React from 'react'

import type { PricingItem } from './pricingConstants'

const CheckIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <circle cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='1.5' />
    <path
      d='M8.5 12.5L10.5 14.5L15.5 9.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const CloseIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox='0 0 90 90' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <g fill='currentColor'>
      <path d='M64.244 25.755c-.781-.781-2.047-.781-2.828 0L45 42.172 28.583 25.755c-.78-.781-2.048-.781-2.828 0-.781.781-.781 2.047 0 2.828L42.172 45 25.755 61.416c-.781.781-.781 2.047 0 2.828.39.391.902.586 1.414.586s1.024-.195 1.414-.586L45 47.828l16.416 16.416c.391.391.902.586 1.414.586s1.023-.195 1.414-.586c.781-.781.781-2.047 0-2.828L47.828 45l16.416-16.416c.781-.781.781-2.047 0-2.828z' />
      <path d='M45 0C20.187 0 0 20.187 0 45c0 24.813 20.187 45 45 45 24.813 0 45-20.187 45-45C90 20.187 69.813 0 45 0zm0 86C22.393 86 4 67.607 4 45S22.393 4 45 4s41 18.393 41 41-18.393 41-41 41z' />
    </g>
  </svg>
)

export const renderPricingItem = (item: PricingItem, index: number) => (
  <li key={`${item.label}-${item.note ?? ''}-${index}`}>
    {item.included ? (
      <CheckIcon className='pricing-item-icon pricing-item-icon-check' />
    ) : (
      <CloseIcon className='pricing-item-icon pricing-item-icon-close' />
    )}
    <span>
      {item.label}
      {item.note ? <small> ({item.note})</small> : null}
    </span>
  </li>
)
